import React from "react"
import {Tooltip} from "antd"
import {useTranslation} from "react-i18next"
import {Icon} from "components/Icon"
import {StudentStatusLabel} from "components/StudentStatusLabel"
import {StudentStatus} from "types/students"
import {Communication} from "types/communication"
import {buildDepartmentRoutingRailText} from "./departmentRoutingRail.helpers"
import styles from "./DepartmentRoutingRail.module.css"

// --black-200
const ICON_COLOR = "#939393"

type Props = {
    routingInfo?: Communication.DepartmentRoutingInfo | null
}

/** Slim line under the department chat header: who is notified for this student's status. */
export function DepartmentRoutingRail({routingInfo}: Props) {
    const {t} = useTranslation(["chat"])
    const text = buildDepartmentRoutingRailText(routingInfo, t)

    if (!text) {
        return null
    }

    return (
        <div className={styles.rail} aria-label={text.plainText} data-testid="department-routing-rail">
            <span className={styles.icon} aria-hidden>
                <Icon icon="BELL" color={ICON_COLOR} />
            </span>
            <span className={styles.text}>
                {text.handledByLabel} <strong className={styles.subunits}>{text.subunitsLabel}</strong>
            </span>
            {routingInfo.status && (
                <>
                    <span className={styles.separator}>·</span>
                    <span className={styles.text}>{t("chat:departmentRouting.studentStatus")}</span>
                    <span className={styles.status}>
                        <StudentStatusLabel
                            status={
                                {
                                    statusId: routingInfo.status.statusId,
                                    name: routingInfo.status.name,
                                    hexColor: routingInfo.status.hexColor || undefined
                                } as StudentStatus
                            }
                        />
                    </span>
                </>
            )}
            <span className={styles.separator}>·</span>
            <span className={styles.text}>{text.notifiedLabel}</span>
            <Tooltip title={text.tooltip}>
                <span className={styles.infoIcon} aria-label={text.tooltip} role="img">
                    <Icon icon="INFO" color={ICON_COLOR} />
                </span>
            </Tooltip>
        </div>
    )
}
